<template>
  <div id="genscanApp"
       data-app="true"
       class="v-application d-block">
    <div class="navContainer">
      <NavBarAdmin />
    </div>
    <div class="container-fluid pt-1">
      <EmptyRouterView />
    </div>
  </div>
</template>

<script>
import NavBarAdmin from '@components/admin/NavBarAdmin';
import EmptyRouterView from '@components/EmptyRouterView';

export default {
  components: {
    NavBarAdmin,
    EmptyRouterView
  }
};
</script>

<style lang="scss">
@import '@design/adminLayout.scss';
</style>
